import {
  FORM_TYPE,
  type FormRef,
  onChangePasswordSubmit,
} from '@atlas/react-forms';
import { useCallback, useRef, useState } from 'react';
import { useLocation } from 'wouter';

import {
  type ChangePasswordRequestError,
  activeFormsRequest,
  changePasswordRequest,
} from 'api/forms.ts';
import { Form } from 'components/Form';
import Loader from 'components/Loader';
import Meta from 'components/Meta';
import { useClientProfile } from 'store';
import { Translation } from 'utils/translations';

import styles from './ChangePassword.module.scss';

const ChangePassword = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [{ sessionToken }, { logout }] = useClientProfile();
  const [, setLocation] = useLocation();
  const formRef = useRef<FormRef>(null);

  const getActiveForms = useCallback(() => {
    return activeFormsRequest({
      query: {
        formType: FORM_TYPE.CHANGE_PASSWORD,
      },
    });
  }, []);

  const handleSubmit = onChangePasswordSubmit(async (values) => {
    setIsLoading(true);

    const { id, ...rest } = values;

    try {
      await changePasswordRequest({
        body: {
          id: Number(id),
          values: rest,
        },
        headers: {
          authorization: `Bearer ${sessionToken}`,
        },
      });

      logout();
      setLocation('~/signin');
    } catch (error) {
      if (formRef.current?.setGlobalErrors) {
        /**
         * this hack allows you to access all form management features
         * in this case it is justified, because we currently do not have normal access to managing the form state
         */
        formRef.current.setGlobalErrors([
          (error as ChangePasswordRequestError).code,
        ]);
      }
    } finally {
      setIsLoading(false);
    }
  });

  return (
    <div className={styles['change-password-wrapper']}>
      <Meta title={<Translation message="title_change_password" />} />
      <h2 className={styles['change-password-title']}>Change password</h2>
      <Form
        ref={formRef}
        formType={FORM_TYPE.CHANGE_PASSWORD}
        // @ts-ignore
        handleSubmit={handleSubmit}
        onError={() => setIsLoading(false)}
        beforeSubmitButton={isLoading && <Loader />}
        getActiveForms={getActiveForms}
        submitButtonText="change_password"
      />
    </div>
  );
};

export default ChangePassword;
